import React from 'react';

import PropTypes from 'prop-types';
import Alert from 'react-bootstrap/Alert';

import { isInFuture } from '@src/utils/dateTimeHelpers';

const ExpiredAlert = ({ expiredAt }) => {
    if (!expiredAt) return null;
    if (isInFuture(expiredAt)) return null;

    return (
        <Alert variant="danger" className="d-flex align-items-start">
            <p className="my-0 ms-1 me-1">
                <span className="fa fa-info-circle" />
            </p>
            <p className="mb-0 w-100">
                <strong>
                    Expiration notice:
                </strong>
                { ' ' }
                This article contains information that has expired. Users will not
                be able to access this content until the expiration has been addressed.
                Visit the admin panel to address the expired content.
            </p>
        </Alert>
    );
};

ExpiredAlert.propTypes = {
    expiredAt: PropTypes.string,
};

export default ExpiredAlert;
